class EditCategoryController {
  /* @ngInject */
  constructor($rootScope, CatalogService, ProductsStore) {
    const that = this;

    that.loading = {
      category: false
    };

    const init = () => {
      if (that.mode === 'create') {
        that.category = {};
      }
      console.log($rootScope.parentId)
    };

    that.$onInit = init;

    that.saveCategory = () => {
      CatalogService.createCategory(that.category.name, $rootScope.parentId).then(
        () => {
          ProductsStore.forceCategoryExpired()
          $rootScope.$broadcast('CATEGORIES_UPDATE');
          that.onCancel()
        }
      )
    }

  }
}

export default EditCategoryController;



/** WEBPACK FOOTER **
 ** ./client/app/components/menu/categories/edit/edit.controller.js
 **/